
import { Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";
export default class IconButton extends Vue {
  @Prop({ type: String, required: true }) icon = "";
}
